function Footer() {
  return (
    <footer className="footer bg-light border-top">
      <div className="container-fluid d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start py-2">
        {/* <p className="mb-2 mb-md-0">
          Copyright ©{" "}
          <a
            href="https://zeabros.com/"
            className="link-primary text-decoration-underline"
          >
            Zeabros
          </a>
        </p> */}

        <div className="d-flex flex-column flex-sm-row align-items-center gap-2">
          <h6 className="mb-0">© 2025 Awasthi Vitality. All rights reserved.</h6>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
